import { render } from "./CalculateTotalSum.vue?vue&type=template&id=b2ed80a6"
import script from "./CalculateTotalSum.vue?vue&type=script&lang=js"
export * from "./CalculateTotalSum.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__